function initialState() {
  return {
    listAlunos: [],
  };
}

const mutations = {
  updateListAlunos(state, listAlunos) {
    if (listAlunos) {
      let alunoFind = null;
      if (state.listAlunos == undefined) state.listAlunos = [];
  
      if (state.listAlunos && state.listAlunos.length > 0) {
        alunoFind = state.listAlunos.findIndex(a => a.alunoId == listAlunos.alunoId && a.aplicacaoProvaId == listAlunos.aplicacaoProvaId);
      }
  
      if (alunoFind == null || alunoFind == -1) {
        state.listAlunos = [...state.listAlunos, listAlunos];
      } else {
        state.listAlunos[alunoFind]['situacao'] = listAlunos.situacao;
        state.listAlunos[alunoFind]['login'] = listAlunos.login;
        state.listAlunos[alunoFind]['nome'] = listAlunos.nome;
        state.listAlunos[alunoFind]['timer'] = listAlunos.timer;
        state.listAlunos[alunoFind]['ordem'] = listAlunos.ordem;
  
        if (listAlunos.quantidadeRespondida) state.listAlunos[alunoFind]['quantidadeRespondida'] = listAlunos.quantidadeRespondida;
        if (listAlunos.dataFimProva) state.listAlunos[alunoFind]['dataFimProva'] = listAlunos.dataFimProva;
      }
    }
  },
  unsetListAlunos(state, listAlunos) {
    state.listAlunos = listAlunos;
  },
};

const actions = {
  setListAlunos(state, listAlunos) {
    state.commit('updateListAlunos', listAlunos);
  },
  unsetListAlunos(state, listAlunos) {
    state.commit('unsetListAlunos', listAlunos);
  },
};

const namespaced = true;

const monitorAlunos = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default monitorAlunos;


// WEBPACK FOOTER //
// ./src/store/monitorAlunos.js